// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__Fsl3k","approved":"Status_approved__3LY9N","rejected":"Status_rejected__2mT-Q","expired":"Status_expired__33Vo0","label":"Status_label__2iCS_"};